import { createFileRoute } from '@tanstack/react-router'
import { AccountEditor } from '../-AccountEditor'

export const Route = createFileRoute('/crm/accounts/$id/')({
  component: AccountDetailPage,
})

function AccountDetailPage() {
  const { id } = Route.useParams()
  return <AccountEditor id={id} />
}
